export default __webpack_public_path__ + "static/media/skillgreek.22f40b7e.png";